// Fixtures of « Réserver » (FICTITIOUS demo, no real ACS offer, price, coach or rule). They REUSE the home slots s1…s11
// (week of 12 October) and add: optional places left and coach per slot, the slots of the following week (19–25 October),
// the member access offer and the cancellation conditions. Remove a field to hide it; nothing is shown as zero by default.
import type { Slot } from "./home-fixtures";
import { DEMO_NOW } from "./demo-context";

/** Demo « now » (central clock, demo-context.ts): Monday 12 October 2026, 16:00, after the morning slots, before tonight's. */
export const NOW = DEMO_NOW;

/** Optional extras per slot id: places left (before the member's own booking) and coach, only where filled. Coach names are the
 *  real ACS coaches (official homepage); which coach leads which slot is a DEMO assignment, not the real planning. */
export const SLOT_EXTRAS: Record<string, { places?: number; coach?: string }> = {
  s1: { places: 2, coach: "Alexandre Simonis" },
  s3: { places: 4 },
  s4: { places: 5, coach: "Alexandre Simonis" },
  s6: { places: 3 },
  s7: { places: 1, coach: "Antoine Chapalain" },
  s8: { places: 6 },
  s9: { places: 2 },
  s12: { places: 6, coach: "Alexandre Simonis" },
  s14: { places: 3 },
};

/** Following week (19–25 October), same day-key convention as the home (d19 … d25). */
export const NEXT_WEEK_SLOTS: Slot[] = [
  { id: "s12", day: "d19", time: "07:00", title: "Small group · Force", minutes: 45, state: "open" },
  { id: "s13", day: "d20", time: "19:00", title: "Small group · Haut du corps", minutes: 45, state: "full" },
  { id: "s14", day: "d21", time: "12:15", title: "Small group · Mobilité", minutes: 45, state: "open" },
  { id: "s15", day: "d23", time: "18:30", title: "Small group · Bas du corps", minutes: 45, state: "open" },
];

/** Access offer: one of three demo configurations; ACTIVE selects the one shown. */
export type Access =
  | { kind: "carnet"; name: string; credits: number; total: number; expires: string; covers: number[]; note: string }
  | { kind: "abonnement"; name: string; includes: string[]; limit: string; covers: number[] }
  | { kind: "illimite"; name: string; covers: number[] };
export const ACCESS_CONFIGS: Record<"carnet" | "abonnement" | "illimite", Access> = {
  carnet: { kind: "carnet", name: "Carnet 10 small groups", credits: 6, total: 10, expires: "2026-12-31", covers: [45], note: "1 crédit par cours de 45 min." },
  abonnement: { kind: "abonnement", name: "Abonnement small group", includes: ["Small groups de 45 min", "Bilans trimestriels"], limit: "2 cours par semaine", covers: [45] },
  illimite: { kind: "illimite", name: "Accès illimité", covers: [45, 60] },
};
export const ACTIVE_ACCESS: keyof typeof ACCESS_CONFIGS = "carnet";

/** Demo ledger of the « carnet » (6 credits left of 10 = 4 used), FICTITIOUS, no real commercial record. Policy of this demo:
 *  a credit is taken when a small group is BOOKED (store.book) and given back on an in-time cancellation (store.cancel). So the
 *  4 used credits are 2 attended small groups of last week (Mon suivi history) and the 2 bookings held this week. Bookings never
 *  count as realised sessions. */
export const CARNET_LEDGER: { date: string; label: string; kind: "attended" | "held" }[] = [
  { date: "2026-10-08", label: "Small group · Force, 07:00", kind: "attended" },
  { date: "2026-10-09", label: "Small group · Corps entier, 18:30", kind: "attended" },
  { date: "2026-10-12", label: "Small group · Cardio, 18:30 (réservé)", kind: "held" },
  { date: "2026-10-14", label: "Small group · Bas du corps, 18:00 (réservé)", kind: "held" },
];

/** Cancellation conditions (demo): free until 12 h before; later, the credit is not returned. */
export const CANCEL_HOURS = 12;
export const PLACE = "Au studio";
